import { useActiveImagesAssetLinesQuery, useActiveTextsAssetLinesQuery } from "../graphql/generated/graphql";

export const useHasDisapprovedAssets = () => {
  const { data: dataActiveImageAssetLines } = useActiveImagesAssetLinesQuery();
  const { data: dataActiveTextAssetLines } = useActiveTextsAssetLinesQuery();

  const hasAnyDisapproved =
    (dataActiveImageAssetLines?.organization?.activeImagesAssetLines || []).filter((line) => line.googleDisapproved)
      .length > 0 ||
    (dataActiveTextAssetLines?.organization?.activeTextsAssetLines || []).filter((line) => line.googleDisapproved)
      .length > 0;

  return hasAnyDisapproved;
};
